import { Box, Container, Grid2 as Grid, Link, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material"
import SkeletonImage from "../../components/ui/SkeletonImage"
import Images from "../../assets/js/Images"
import Icons from "../../assets/js/Icons"
import { Link as NavLink } from "react-router-dom"

function Notification() {
  return (
    <Box component="section" py={10}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              sx={{
                mt: "10px",
                mb: "20px",
                fontSize: "2rem",
                fontWeight: "700",
                color: "other.color1"
              }}
              component="h1"
            >Thanks for visiting our web site.
            </Typography>
            <Typography
              sx={{
                mb: "20px",
                fontSize: "22px",
                fontWeight: "500",
                color: "other.color1"
              }}
              component="h3"
            >We are working hard to bring this service to you as we value you the most
            </Typography>
            <Typography
              sx={{
                mb: "20px",
                color: "other.color1"
              }}
            >In the meantime, you can...
            </Typography>
            <List sx={{ p: "0" }}>
              <ListItem sx={{ p: "0", color: "other.color1", mb: "15px" }}>
                <ListItemIcon sx={{ minWidth: "auto", mr: "8px", fontSize: "24px", color: "other.color1" }}>
                  <Icons.TickSolid />
                </ListItemIcon>
                <ListItemText sx={{ m: 0 }}>
                  See what's happening at Innerpal on our awesome <Link
                    to="/blogs"
                    underline="hover"
                    component={NavLink}
                    sx={{ fontWeight: "700" }}
                  >blog
                  </Link>.
                </ListItemText>
              </ListItem>
              <ListItem sx={{ p: "0", color: "other.color1", mb: "15px" }}>
                <ListItemIcon sx={{ minWidth: "auto", mr: "8px", fontSize: "24px", color: "other.color1" }}>
                  <Icons.TickSolid />
                </ListItemIcon>
                <ListItemText sx={{ m: 0 }}>
                  Read more about our topic on the <Link
                    to="/forums"
                    underline="hover"
                    component={NavLink}
                    sx={{ fontWeight: "700" }}
                  >forum
                  </Link>.
                </ListItemText>
              </ListItem>
            </List>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                ml: "auto",
                maxWidth: "400px",
                aspectRatio: "1/1"
              }}
            >
              <SkeletonImage
                src={Images?.noti}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Notification